<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h;
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { onMount } from 'svelte';
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { ycSSOThirdPartyAuth } from '../../../../../js/ycapp';
import { resolveUrl } from '../../../../../js/url';
import { ycSSOSetState } from '../../../../../js/ycapp';
import { loadStripe } from '@stripe/stripe-js';
import { f7 } from 'framework7-svelte';
import ActionButton from "../ActionButton/ActionButton.svelte";
import { CardsPageContext, CardsPageContextKey } from '../../../common/context';
import { getContext } from 'svelte';
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
const pageContext = getContext(CardsPageContextKey);
let stripe = null;
let elements = null;
let workflowData = null;
let paymentFormReady = false;
let mounted = false;
let stripeLoaded = false;
$: publishableKey = (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.publishableKey;
$: productId = (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.productId;
$: priceId = (_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.priceId;
$: title = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.title) || "Subscribe";
$: titleColor = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.titleColor) || "var(--sso22-learnmore-title-color, #fff)";
$: backgroundColor = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.backgroundColor) || 'transparent';
$: fontFamily = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.fontFamily) || null;
$: nextPage = ((_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.nextPage) || null;
function handleStripeCallback(paymentIntentId, paymentIntentClientSecret) {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, function* () {
        console.log('got callback from Stripe', paymentIntentId, paymentIntentClientSecret);
        f7.preloader.show('white');
        let result;
        try {
            result = yield signonManager.subscriptionUpdateWithStripe(productId, priceId, 'payment', null, paymentIntentId);
        }
        finally {
            f7.preloader.hide();
        }
        if (!result.success || ((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.UpdateResult) === null || _b === void 0 ? void 0 : _b.Service) !== 'STRIPE' || ((_f = (_e = (_d = (_c = result.data) === null || _c === void 0 ? void 0 : _c.UpdateResult) === null || _d === void 0 ? void 0 : _d.Product) === null || _e === void 0 ? void 0 : _e.Stripe) === null || _f === void 0 ? void 0 : _f.WorkflowState) !== 'active') {
            alert('Your subscription could not be activated. Please try again later.');
            //f7.view.main.router.back();
        }
        if (nextPage) {
            resolveUrl(nextPage).func();
        }
        else {
            signonManager.fireWorkflowEndEvent();
        }
    });
}
onMount(() => __awaiter(void 0, void 0, void 0, function* () {
    /*
        the code below is run if there is a Stripe callback

        payment_intent	The unique identifier for the PaymentIntent.
        payment_intent_client_secret	The client secret of the PaymentIntent object.
    */
    const qsPaymentIntentId = pageContext.query['payment_intent'];
    const qsPaymentIntentClientSecret = pageContext.query['payment_intent_client_secret'];
    if (qsPaymentIntentId && qsPaymentIntentClientSecret) {
        handleStripeCallback(qsPaymentIntentId, qsPaymentIntentClientSecret);
        return;
    }
    // if not a callback, set mounted = true
    mounted = true;
}));
function mountPaymentElement() {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, function* () {
        stripeLoaded = true;
        /*
            the code below is run on the initial load
        */
        stripe = yield loadStripe(publishableKey);
        f7.preloader.show('white');
        let result = yield signonManager.subscriptionUpdateWithStripe(productId, priceId, 'init');
        f7.preloader.hide();
        console.log('subscription result', result);
        if (!result.success || ((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.UpdateResult) === null || _b === void 0 ? void 0 : _b.Service) !== 'STRIPE' || ((_f = (_e = (_d = (_c = result.data) === null || _c === void 0 ? void 0 : _c.UpdateResult) === null || _d === void 0 ? void 0 : _d.Product) === null || _e === void 0 ? void 0 : _e.Stripe) === null || _f === void 0 ? void 0 : _f.WorkflowState) !== 'payment') {
            alert('Failed to initialize Stripe payments, please try again later.');
            f7.view.main.router.back();
            return;
        }
        workflowData = result.data.UpdateResult.Product.Stripe;
        const options = {
            clientSecret: workflowData.ClientSecret,
            // Fully customizable with appearance API.
            appearance: {},
        };
        // Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 5
        elements = stripe.elements(options);
        // Create and mount the Payment Element
        const paymentElement = elements.create('payment');
        paymentElement.on('ready', function () {
            paymentFormReady = true;
        });
        paymentElement.mount('#payment-element');
    });
}
//$: console.log('SubscribeWithStripe status', mounted, publishableKey, productId, priceId, !stripeLoaded);
$: if (mounted && publishableKey && productId && priceId && !stripeLoaded) {
    stripeLoaded = true;
    mountPaymentElement();
}
function onSubscribeClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        //signonManager.fireWorkflowEndEvent();
        const { error, paymentIntent } = yield stripe.confirmPayment({
            //`Elements` instance that was used to create the Payment Element
            elements,
            confirmParams: {
                return_url: window.location.href,
            },
            redirect: 'if_required'
        });
        if (error) {
            // This point will only be reached if there is an immediate error when
            // confirming the payment. Show error to your customer (for example, payment
            // details incomplete)
            const messageContainer = document.querySelector('#error-message');
            messageContainer.textContent = error.message;
        }
        else if (paymentIntent) {
            console.log('handling direct payment callback', paymentIntent);
            handleStripeCallback(paymentIntent.id, paymentIntent.client_secret);
        }
        else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
        }
        return true;
    });
}
</script>

<CardBase {element}>
    <form id="payment-form">
        <div id="payment-element" style="padding-bottom: 10px;">
            <!-- Elements will create form elements here -->
        </div>
        {#if paymentFormReady}
        <ActionButton onClick={onSubscribeClick} title={title} fontColor={titleColor} backgroundColor={backgroundColor} fontFamily={fontFamily} textTransform="none" borderColor="#000" borderRadius="38px" />
        {/if}
        <div id="error-message" style="padding-top: 10px;">
            <!-- Display error message to your customers here -->
        </div>
    </form>
</CardBase>
